export default "__VITE_ASSET__CJ8WZbff__"